import React from 'react';
import { useEffect, useState, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { useAxios } from '../../../../utils/Axios';
import swal from 'sweetalert';
import PopUp from '../../../../components/UIElements/PopUp';
import ErrorPopUp from '../../../../components/UIElements/ErrorPopup';
import Context from '../../../../store/Context';
import deleteIcon from '../../../../assests/icons/delete.svg';

function DevicesList(props) {
    const [devicesList, setDevicesList] = useState([]);
    const axiosInstance = useAxios();
    const { state, actions } = useContext(Context);

    useEffect(() => {
        fetchDevicesList();
    }, [axiosInstance]);

    useEffect(() => {
        console.log(props);
    }, [props]);

    const fetchDevicesList = () => {

        if (axiosInstance) {
            actions({ type: 'setState', payload: { ...state, blocking: true } })
            axiosInstance
                // .get('http://34.89.72.62/cr/api/v1/projects')
                .get(`${process.env.REACT_APP_LORA_URL}/devices?limit=100&applicationId=${props.match.params.id}`)
                .then((response) => {
                    // console.log(response);
                    setDevicesList(response.data.result);

                    actions({ type: 'setState', payload: { ...state, blocking: false } })
                })
                .catch((err) => {
                    // console.log(err);
                    setDevicesList([{"devEUI":"18c7dd5ebc76e476","name":"device1","applicationID":"12","description":"1","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"19c7cd5ebc76e476","name":"device4","applicationID":"12","description":"1","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"1111111111111112","name":"sample","applicationID":"12","description":"sensor","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"01d266da3f565c96","name":"sample2","applicationID":"12","description":"2","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"5a875fd6141c16a1","name":"sample3","applicationID":"12","description":"3","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"0ed4e623299d2c5b","name":"sample4","applicationID":"12","description":"4","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"c54bd29c3d8680fb","name":"sample6","applicationID":"12","description":"6","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"26604827957cc632","name":"testdev","applicationID":"12","description":"ss","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"27604827957cc632","name":"testdev1","applicationID":"12","description":"s7","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null},{"devEUI":"27804827957cc632","name":"testdev2","applicationID":"12","description":"s7","deviceProfileID":"e48430bf-ac38-4815-a57e-5cda3e3f7d4c","deviceProfileName":"deviceprofile1","deviceStatusBattery":255,"deviceStatusMargin":256,"deviceStatusExternalPowerSource":false,"deviceStatusBatteryLevelUnavailable":true,"deviceStatusBatteryLevel":0,"lastSeenAt":null}])
                    actions({ type: 'setState', payload: { ...state, blocking: false } })
                });

        }
    };

    //Code to return row on conditions
    function getRow(obj) {
        let lastseen = "n/a";
        let margin = "n/a";
        let battery = "n/a";
    
        if (obj.lastSeenAt !== undefined && obj.lastSeenAt !== null) {
          lastseen = obj.lastSeenAt;
        }
    
        if (!obj.deviceStatusExternalPowerSource && !obj.deviceStatusBatteryLevelUnavailable) {
          battery = `${obj.deviceStatusBatteryLevel}%`
        }
    
        if (obj.deviceStatusExternalPowerSource) {
          battery = `Charging`;
        }
    
        if (obj.deviceStatusMargin !== undefined && obj.deviceStatusMargin !== 256) {
          margin = `${obj.deviceStatusMargin} dB`;
        }
    
        return(
            <tr key={obj.devEUI} >
            <td>{lastseen}</td>
            <td>
                <Link to={`/lora/applications/${props.match.params.id}/deviceinfo/${obj.devEUI}`}>

                    {
                        obj.name.length < 21 ? (
                            <>{obj.name.slice(0, 20)}</>
                        ) : (
                                <>{obj.name.slice(0, 20) + '...'}</>
                            )
                    }

                </Link>
            </td>
            <td>
               {obj.devEUI}
            </td>
            <td>
                {obj.deviceProfileName}
            </td>
            <td>
                {margin}
            </td>
            <td>
                {battery}
            </td>
            {props.options.deleteDevice == true ? (
                <>
                    <td>
                        <img src={deleteIcon} className="iconCustom" name={obj.devEUI} onClick={e => deleteDevice(e.target)} />
                    </td>
                </>
            ) : null}
        </tr>
          
        );
      }
    
    //code to delete device
    const deleteDevice = (e) => {
        let reqId = e.getAttribute('name')
        swal({
			title: "Are you sure?",
			text: "Device will be deleted",
			icon: "warning",
			buttons: true,
			dangerMode: true,
			className: "dangerSwal"
		})
			.then((willDelete) => {
				if (willDelete) {
					axiosInstance
						.delete(`${process.env.REACT_APP_LORA_URL}/devices/${reqId}`)
						.then((response) => {
							PopUp("Device Deleted Successfully");
                            setTimeout(() => {
                                fetchDevicesList()    
                            }, 500);
							// sendUpdateState()
						})
						.catch((err) => {
							// console.log(err);
							ErrorPopUp("Deleting Failed. Try Again");
						});
				}
			});
    }

    return (
        <div>
            <div className="project-table-group">
                <Table responsive borderless className="projectTableData">
                    <thead>
                        <tr>
                            <th>Last Seen</th>
                            <th>Device name</th>
                            <th>Device EUI</th>
                            <th>Device profile</th>
                            <th>Link margin</th>
                            <th>Battery</th>
                            {props.options.deleteDevice == true ? (
                                <>
                                <th>Delete</th>
                                </>
                            ) : null}
                        </tr>
                    </thead>
                    <tbody>
                        {devicesList.length > 0 ? (
                            <>
                                {devicesList.map((item) => (
                                    getRow(item)
                                ))}
                            </>
                        ) : (
                            <>
                                <tr>
                                    <td colSpan="7">No Data Found</td>
                                </tr>
                            </>
                        )}

                    </tbody>
                </Table>

            </div>
            {props.options.createLoraDevice == true ? (
                <>
                    <div className="col-md-12 text-right no-padding" >
                        <Button className="btnDefault" style={{ margin: '2%' }} href={`#/lora/applications/${props.match.params.id}/create`}>
                            + CREATE DEVICE
                        </Button>
                    </div>
                </>
            ) : null}
        </div>
    )
}

export default DevicesList;
